// WhatsApp Floating Button JavaScript
document.addEventListener('DOMContentLoaded', function() {
  const whatsappButton = document.querySelector('.whatsapp-float');
  
  if (whatsappButton) {
    // Add click tracking
    whatsappButton.addEventListener('click', function() {
      // Track click event (you can add Google Analytics or other tracking here)
      if (typeof gtag !== 'undefined') {
        gtag('event', 'click', {
          'event_category': 'WhatsApp',
          'event_label': 'Floating Button'
        });
      }
    });

    // Add scroll effect
    let lastScrollTop = 0;
    window.addEventListener('scroll', function() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > lastScrollTop && scrollTop > 100) {
        // Scrolling down
        whatsappButton.style.transform = 'scale(0.8)';
        whatsappButton.style.opacity = '0.7';
      } else {
        // Scrolling up
        whatsappButton.style.transform = 'scale(1)';
        whatsappButton.style.opacity = '1';
      }
      
      lastScrollTop = scrollTop;
    });

    // Add hover effect
    whatsappButton.addEventListener('mouseenter', function() {
      this.style.transform = 'scale(1.1)';
    });

    whatsappButton.addEventListener('mouseleave', function() {
      this.style.transform = 'scale(1)';
    });

    // Add pulse animation on page load
    setTimeout(function() {
      whatsappButton.style.animation = 'pulse 2s infinite';
    }, 1000);
  }
});
